import { render, staticRenderFns } from "./WDSCategorySelector.vue?vue&type=template&id=df8e7448&scoped=true"
import script from "./WDSCategorySelector.vue?vue&type=script&lang=js"
export * from "./WDSCategorySelector.vue?vue&type=script&lang=js"
import style0 from "./WDSCategorySelector.vue?vue&type=style&index=0&id=df8e7448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8e7448",
  null
  
)

export default component.exports